var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"Benefits",class:_vm.displayIsDesktop ? 'py-16' : 'py-7'},_vm._l((Object.entries(_vm.images)),function([title, url],index){return _c('BenefitsTile',{key:index,attrs:{"url":url,"title":title,"tile-color":_vm.colors.inverted}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }